var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: {
      title: _vm.title,
      hideRgtBtn: "",
      outsideScrollToBottom: _vm.outsideScrollToBottom,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c("PaginationController", {
                  attrs: {
                    getDataActionName: _vm.actionName,
                    historyLimit: _vm.historyLimit,
                    haveSearchBox: "",
                    searchBoxLabel:
                      _vm.$t("upc") + "/" + _vm.$t("trackingNumber"),
                    haveNoEndDate: "",
                    outsideScrollToBottom: _vm.popupToBottom
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "dataTable",
                      fn: function() {
                        return [
                          _c("v-data-table", {
                            staticClass: "elevation-2 myDense",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.logs,
                              "hide-actions": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "subheading" },
                                      [
                                        _c(
                                          "v-layout",
                                          { attrs: { row: "", "no-wrap": "" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(props.index + 1) +
                                                "\n                  "
                                            ),
                                            props.item.beforeValue[0].isAbnormal
                                              ? _c(
                                                  "v-icon",
                                                  { attrs: { color: "red" } },
                                                  [_vm._v("flag")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.toTimestampString(
                                            props.item.createTime
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.headers[2].text === _vm.$t("tracking")
                                      ? _c(
                                          "td",
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                staticStyle: { height: "100%" },
                                                attrs: {
                                                  column: "",
                                                  "justify-space-between": ""
                                                }
                                              },
                                              _vm._l(
                                                props.item.trackings,
                                                function(tracking, index) {
                                                  return _c(
                                                    "v-layout",
                                                    {
                                                      key: "item" + index,
                                                      attrs: {
                                                        "align-center": ""
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(tracking))]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      _vm._l(props.item.beforeValue, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: "item" + index },
                                          [
                                            _c("v-layout", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.upcMap[item.upc]
                                                    ? _vm.upcMap[item.upc]
                                                        .description
                                                    : "New product"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              {
                                                class:
                                                  item.upc !==
                                                  props.item.actionPayload[
                                                    index
                                                  ].upc
                                                    ? "font-green"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("upc")) +
                                                    ": " +
                                                    _vm._s(item.upc)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              {
                                                class:
                                                  item.quantity !==
                                                  props.item.actionPayload[
                                                    index
                                                  ].quantity
                                                    ? "font-green"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("quantity")) +
                                                    ": " +
                                                    _vm._s(item.quantity)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.isAbnormal
                                              ? [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      class:
                                                        item.abnormalQty !==
                                                        props.item
                                                          .actionPayload[index]
                                                          .abnormalQty
                                                          ? "font-green"
                                                          : ""
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "abnormalQuantity"
                                                          )
                                                        ) +
                                                          ": " +
                                                          _vm._s(
                                                            item.abnormalQty
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      class:
                                                        item.normalQty !==
                                                        props.item
                                                          .actionPayload[index]
                                                          .normalQty
                                                          ? "font-green"
                                                          : ""
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "normalQuantity"
                                                          )
                                                        ) +
                                                          ": " +
                                                          _vm._s(item.normalQty)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              {
                                                class:
                                                  item.organizationId !==
                                                  props.item.actionPayload[
                                                    index
                                                  ].organizationId
                                                    ? "font-green"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("organizationId")
                                                  ) +
                                                    ": " +
                                                    _vm._s(item.organizationId)
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      _vm._l(props.item.actionPayload, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: "item" + index },
                                          [
                                            _c("v-layout", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.upcMap[item.upc]
                                                    ? _vm.upcMap[item.upc]
                                                        .description
                                                    : "New product"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("v-layout", [
                                              _vm._v(
                                                _vm._s(_vm.$t("upc")) +
                                                  ": " +
                                                  _vm._s(item.upc)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("v-layout", [
                                              _vm._v(
                                                _vm._s(_vm.$t("quantity")) +
                                                  ": " +
                                                  _vm._s(item.quantity)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            item.isAbnormal
                                              ? [
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "abnormalQuantity"
                                                        )
                                                      ) +
                                                        ": " +
                                                        _vm._s(item.abnormalQty)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("normalQuantity")
                                                      ) +
                                                        ": " +
                                                        _vm._s(item.normalQty)
                                                    )
                                                  ])
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("v-layout", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("organizationId")
                                                ) +
                                                  ": " +
                                                  _vm._s(item.organizationId)
                                              )
                                            ])
                                          ],
                                          2
                                        )
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        _vm._s(props.item.userInfo.userName)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(_vm._s(props.item.siteName))
                                    ]),
                                    _vm._v(" "),
                                    _vm.actionName === "getAdjustLogs"
                                      ? _c(
                                          "td",
                                          {
                                            class: _vm.noteClass,
                                            staticStyle: {
                                              "white-space": "pre-wrap"
                                            }
                                          },
                                          [_vm._v(_vm._s(props.item.note))]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.changeLogs,
                    callback: function($$v) {
                      _vm.changeLogs = $$v
                    },
                    expression: "changeLogs"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1588e9a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1588e9a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseChangeLogs.vue
// module id = null
// module chunks = 